module.exports = __webpack_public_path__ + "media/images/area/area_wakayamaM400-8439ce882948c9954ce596c77673e0d3.jpg";